import { SET_CUSTOMER_VEHICLES } from './actionTypes';
import xws from 'api/xws/';

// Selector
import { getWebkey } from 'store/reducers/queryParams/selectors';
import { getTokenId } from 'store/reducers/tokenId/selectors';
import { getLocaleCode } from 'store/reducers/dealerLocale/selectors';
import {
  getRecaptchaToken,
  isRecaptchaEnabledOnFindMe
} from 'store/reducers/dealerSettings/selectors';

// Actions
import { ajaxCallbacks } from 'store/reducers/ajaxCall/actions';

// Constants
import { getService } from 'constants/ajax';
import { SEARCH_CRITERIA_FIND_ME } from 'constants/findMe';

const { LICENSE_NUMBER } = SEARCH_CRITERIA_FIND_ME;

export const getCustomerVehicles = (tokenId, fieldName, fieldValue) => async (
  dispatch,
  getState
) => {
  try {
    const webkey = getWebkey(getState());
    const customerVehiclesService = getService('customerVehicles');
    const gRecaptchaResponse = getRecaptchaToken(getState());
    const sendRecaptchaToken = isRecaptchaEnabledOnFindMe(getState());
    const dlrCountryCode = getLocaleCode(getState()).split('_')[1];
    customerVehiclesService.setPathVars({ webkey });
    customerVehiclesService.setCallBacks(dispatch(ajaxCallbacks()));
    const {
      data: { vehicles, success }
    } = await xws(customerVehiclesService).get(
      customerVehiclesService.getPath(),
      {
        params: {
          tokenId: getTokenId(getState()),
          [fieldName]:
            fieldName === LICENSE_NUMBER
              ? fieldValue.toUpperCase()
              : fieldValue,
          dlrCountryCode,
          ...(sendRecaptchaToken && { gRecaptchaResponse })
        }
      }
    );
    if (vehicles) {
      dispatch(setCustomerVehicles(vehicles));
    }
    return success;
  } catch (e) {
    /* eslint-disable no-console */
    console.error(e);
    /* eslint-enable no-console */
    return false;
  }
};

const setCustomerVehicles = vehicles => {
  return {
    type: SET_CUSTOMER_VEHICLES,
    payload: vehicles
  };
};



// WEBPACK FOOTER //
// ./src/store/reducers/customerVehicles/actions.js